import { AlertCircleIcon, RefreshCwIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

interface InlineErrorProps {
  title: string;
  description: string;
  onRetry?: () => void;
  className?: string;
}

export function InlineError({ title, description, onRetry, className }: InlineErrorProps) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-16 text-center ${className ?? ""}`}>
      <div className="flex size-10 items-center justify-center bg-destructive/10 text-destructive">
        <AlertCircleIcon className="size-5" />
      </div>
      <div>
        <p className="text-sm font-semibold">{title}</p>
        <p className="mt-0.5 max-w-xs text-xs text-muted-foreground">{description}</p>
      </div>
      {onRetry && (
        <Button size="sm" variant="outline" className="mt-1" onClick={onRetry}>
          <RefreshCwIcon />
          Try again
        </Button>
      )}
    </div>
  );
}
